var feeJS = feeJS || {};
feeJS.listenerParams = {

  scrollDown: {
    selector: '.js-scrollDown',
    event: 'click',
  },

  scrollUp: {
    selector: '.js-scrollUp',
    event: 'click',
  },

  extendArtistList: {
    selector: '.js-artistList',
    event: 'click',
  }
}